import { OutlinedInput } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

const MIN_ROWS = 3;

interface InputProps extends InputRenderer {
  multiline?: boolean;
}

const DefaultInput = ({ fieldState, inputProps, multiline, placeholder, type }: InputProps) => {
  return (
    <>
      <OutlinedInput
        fullWidth
        error={fieldState?.invalid}
        id={inputProps.name}
        minRows={multiline ? MIN_ROWS : undefined}
        multiline={multiline}
        placeholder={placeholder}
        type={type}
        {...inputProps}
        value={inputProps.value ?? ''}
      />
    </>
  );
};

export default DefaultInput;
